import {get as dataGetter} from 'lodash';
import {AvailableSocials} from '@/store/models';
import {setCookie} from '@/commons/cookies';

// eslint-disable-next-line no-underscore-dangle
const INITIAL_STATE = window.__INITIAL_STATE__ || {};

export const availablesSocial: AvailableSocials = dataGetter(INITIAL_STATE, 'settings.socialAvailables', []);

export function socialPopup(urlSocial: string) {
    setCookie('social_login_redirect', 'checkout/cart/', 1, '/');
    window.open(
        urlSocial,
        'targetWindow',
        `toolbar=no,location=no,status=no,menubar=no,scrollbars=yes,resizable=yes,width=500,height=420`
    );
}
